<template>
  <section class="container-fluid">
    <section v-if="sale.id != null">
      <ValidationObserver ref="form" v-slot="{ invalid }">
        <form @submit.prevent="showConfirm">
          <!-- Items -->
          <CRow class="justify-content-center">
            <CCol sm="12">
              <CCard>
                <CCardHeader>
                  <strong>Items</strong>
                </CCardHeader>
                <CCardBody>
                  <SalesItemsList
                    ref="SaleItems"
                    :sale_id="sale.id"
                    @salesItemsList="salesItemsList"
                  ></SalesItemsList>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
          <!-- datos de pago   -->
          <CRow class="justify-content-center">
            <CCol sm="12">
              <CCard>
                <CCardHeader>
                  <strong>Datos de pago</strong>
                </CCardHeader>
                <CCardBody>
                  <section class="row">
                    <!-- Nombre / Razón social -->
                    <div class="col">
                      <div class="form-group required">
                        <ValidationProvider
                          name="nit_name"
                          rules="required|max:180"
                          v-slot="{ valid, errors }"
                        >
                          <label class="control-label" for="nit_name"
                            >Nombre / Razón social</label
                          >
                          <input
                            type="text"
                            v-model="sale.customer.nit_name"
                            class="form-control form-control-sm"
                            id="nit_name"
                            maxlength="180"
                          />
                          <b-form-invalid-feedback :state="valid">{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </ValidationProvider>
                      </div>
                    </div>
                    <!-- Documento / NIT -->
                    <div class="col">
                      <div class="form-group required">
                        <ValidationProvider
                          name="nit_document"
                          rules="required|max:15"
                          v-slot="{ valid, errors }"
                        >
                          <label class="control-label" for="nit_document"
                            >Documento / NIT</label
                          >
                          <input
                            type="text"
                            v-model="sale.customer.nit_document"
                            class="form-control form-control-sm"
                            id="nit_document"
                            maxlength="15"
                          />
                          <b-form-invalid-feedback :state="valid">{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </ValidationProvider>
                      </div>
                    </div>
                  </section>
                  <section class="row">
                    <!-- Formas de pago -->
                    <div class="col">
                      <PaymentMethodRadioInput
                        v-model="sale.payment_method_id"
                        :name="'payment_method_id'"
                        :rules="'required'"
                        :value="sale.payment_method_id"
                      />
                    </div>
                    <!-- Observación de pago -->
                    <div class="col">
                      <div class="form-group">
                        <ValidationProvider
                          name="observation"
                          rules="max:180"
                          v-slot="{ valid, errors }"
                        >
                          <label class="control-label" for="observation"
                            >Observación de pago</label
                          >
                          <input
                            type="text"
                            v-model="sale.observation"
                            class="form-control form-control-sm"
                            id="observation"
                            maxlength="180"
                          />
                          <b-form-invalid-feedback :state="valid">{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </ValidationProvider>
                      </div>
                    </div>
                  </section>

                  <section class="row">
                    <div class="col">
                      <router-link
                        to="/ventas"
                        custom
                        v-slot="{ href, navigate }"
                      >
                        <a
                          :href="href"
                          class="card-header-action btn btn-sm btn-danger"
                          @click="navigate"
                        >
                          <CIcon size="sm" name="cil-x-circle" /> Cancelar
                        </a>
                      </router-link>
                      <button
                        type="submit"
                        class="btn btn-success btn-sm float-right"
                        variant="success"
                        :disabled="invalid || editLoader || countItems <= 0"
                      >
                        <span v-if="!editLoader">
                          <CIcon size="sm" name="cil-save" />
                          Guardar
                        </span>
                        <span v-if="editLoader">
                          Cargando
                          <CSpinner color="success" size="sm" />
                        </span>
                      </button>
                    </div>
                  </section>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </form>
      </ValidationObserver>
    </section>
  </section>
</template>
<script>
import { BFormInvalidFeedback, BFormTextarea } from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
import { extend } from "vee-validate";
import { required, max } from "vee-validate/dist/rules";
//services
import Sales from "@/plugins/services/sales";
//components
import SalesItemsList from "@/entities/sales-items/SalesItemsList";
import PaymentMethodRadioInput from "@/entities/payment-methods/PaymentMethodRadioInput";

export default {
  name: "SaleEdit",
  components: {
    BFormInvalidFeedback,
    BFormTextarea,
    SalesItemsList,
    PaymentMethodRadioInput,
  },
  data() {
    return {
      sale: {
        id: null,
      },
      customersOptions: [],
      editLoader: false,
      dataLoader: false,
      countItems: 0,
    };
  },
  computed: {
    computedForm() {
      return this.$refs.form;
    },
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido",
    });

    extend("max", {
      ...max,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como máximo.",
    });
  },
  mounted() {
    const { id } = this.$route.params;
    this.getData(id);
  },
  methods: {
    getData(id) {
      this.dataLoader = true;
      Sales.getOne(id)
        .then((res) => {
          this.sale = res.data;
          this.sale.payment_method_id = 2;
          this.$refs.SaleItems.getItems(this.sale.id);
          this.dataLoader = true;
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Venta no encontrada.");
            this.$router.push("/ventas");
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.$router.push("/ventas");
          }
          this.dataLoader = false;
        });
    },
    edit(print) {
      this.editLoader = true;
      const { id } = this.$route.params;
      this.sale.modified_by = this.userAuth.username;
      this.sale.draft = false;
      Sales.edit(id, this.sale)
        .then((res) => {
          this.editLoader = false;
          if (res.data.success && print == true) {
            let saleUrl = `${process.env.MIX_APP_API_ENDPOINT}/ventas/individual-pdf/${res.data.data.id}`;
            Utils.printPdf(saleUrl);
            Utils.setFlash("success", res.data.message);
            this.$router.push("/ventas");
          } else {
            Utils.setFlash("success", res.data.message);
            this.$router.push("/ventas");
          }
        })
        .catch((err) => {
          this.editLoader = false;
          if (err.response && err.response.status == 422) {
            this.$refs.form.setErrors(err.response.data.errors);
          }
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Venta no encontrada.");
            this.$router.push("/ventas");
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error al editar(500).");
            this.$router.push("/ventas");
          }
        });
    },
    showConfirm() {
      this.$swal({
        title: "Guardar venta",
        icon: "warning",
        confirmButtonText: "Guardar e imprimir",
        cancelButtonText: "Guardar",
        cancelButtonColor: "#28a745",
        showCancelButton: true,
        allowEscapeKey: false,
        allowOutsideClick: false,
        allowEnterKey: true,
      }).then((res) => {
        if (res.value) {
          this.edit(true);
        } else if (res.dismiss == "cancel") {
          this.edit(false);
        } else if (res.dismiss == "esc") {
          this.edit(false);
        }
      });
    },
    salesItemsList(data) {
      this.countItems = data.countItems;
      this.sale.total_cost = data.totalItems;
      this.sale.total_discounts = 0;
      this.sale.total_fines = 0;
      this.sale.total_with_discounts_and_fines =
        this.sale.total_cost + this.sale.total_fines;
      this.sale.total_paid = this.sale.total_with_discounts_and_fines;
    },
  },
};
</script>
